import React from 'react';
import './certificate.css';
import certifi from '../assets/certificate.jpg'; // This is the correct import
//import pamphlet from '../assets/pamphlet.jpg'; // This is the correct import

const certificateImages = [
  certifi,
  
  // Add more imports if needed for other certificates
];

const Certificate = () => {
  return (
    <div className="certificate-container">
      <h1>प्रमाणपत्र</h1>
      <div className="certificate-grid">
        {certificateImages.map((src, index) => (
          <div key={index} className="certificate-item">
            <img src={src} alt={`certificate ${index + 1}`} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Certificate;
